import { MouseEventHandler } from 'react';

import { ButtonFilterProps, FilterFormProps } from '@/models/FilterConfig';
import OutlineButton from '@/components/ui/custom/buttons/OutlineButton';
import ConditionalWrapper from '@/components/ui/custom/ConditionalWrapper';
import Badge from '@/components/ui/custom/dataDisplay/Badge';

export default function ButtonFilter(
  props: ButtonFilterProps & FilterFormProps,
) {
  const { setValue, value, label, name, active, badge } = props;

  const handleClick: MouseEventHandler<HTMLButtonElement> = () => {
    let newValue;
    if (active) newValue = undefined;
    else newValue = value ?? true;
    setValue(name, newValue);
  };

  return (
    <ConditionalWrapper
      condition={!!badge}
      wrapper={<Badge count={badge} position="-right-1 -top-1" />}
    >
      <OutlineButton
        aria-pressed={!!value}
        text={label}
        className={{
          base: 'lowercase text-[0.75rem] sm:text-[0.875rem] px-2.5 py-0',
        }}
        onClick={handleClick}
        active={active}
      />
    </ConditionalWrapper>
  );
}
